import React, { useEffect, useState } from 'react';
import { Button, formatPrice, IconEye } from 'takeat-design-system-ui-kit';
import { CardContent, CardHeader, ReviewCardContainer } from './styles';
import { useTheme } from 'styled-components';
import { StarsComponent } from '../StarsComponent';
import { ReviewsModal } from '../ReviewsModal';
import api from '~/services/api';
import { addHours, format, set } from 'date-fns';
import { useAuth } from '~/context/AuthContext';

export const ReviewCard = () => {
  const theme = useTheme();
  const { websocketManager } = useAuth();
  const [modalOpen, setModalOpen] = useState(false);
  const [reviews, setReviews] = useState([]);
  const [dateSince, setDateSince] = useState(null);

  const amount = reviews.length;
  const average =
    amount === 0
      ? 0
      : reviews.reduce((acc, review) => acc + review.stars, 0) / amount;

  const getReviews = async () => {
    try {
      const { data } = await api.get('/restaurants/ratings-operation');

      setReviews(data.ratings);
      setDateSince(addHours(new Date(data.from_date), 3));
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    getReviews();
  }, []);

  useEffect(() => {
    if (websocketManager) {
      websocketManager.addMessageCallback(9, (dt) => {
        if (dt.type === 'new-rating') {
          const newRating = dt.item;

          setReviews((state) => [newRating, ...state]);
        }
      });
    }
  }, [websocketManager]);

  return (
    <ReviewCardContainer>
      <CardContent>
        <CardHeader>
          <h3>
            {amount} Avaliações | {formatPrice(average, { hasPrefix: false })}
          </h3>
          <StarsComponent value={average} />
        </CardHeader>
        <span>
          Desde {dateSince ? format(dateSince, 'dd/MM/yy - HH:mm') : '-'}
        </span>
      </CardContent>
      <Button
        icon={<IconEye />}
        variant="outlined"
        customColor={theme.colors.yellow.default}
        onClick={() => setModalOpen(true)}
      />

      <ReviewsModal
        open={modalOpen}
        toggle={() => setModalOpen(false)}
        reviews={reviews}
      />
    </ReviewCardContainer>
  );
};
